function MonsterMap(key) {

    return(monsterMap[key])

}

export default MonsterMap;

let monsterMap = {
1001:"SCORPION",
1002:"PORING",
1004:"HORNET",
1005:"FARMILIAR",
1007:"FABRE",
1008:"PUPA",
1009:"CONDOR",
1010:"WILOW",
1011:"CHOCHO",
1012:"RODA_FROG",
1013:"WOLF",
1014:"SPORE",
1015:"ZOMBIE",
1016:"SKEL_ARCHER",
1018:"CREAMY",
1019:"PECOPECO",
1020:"MANDRAGORA",
1023:"ORK_WARRIOR",
1024:"WORM_TAIL",
1025:"SNAKE",
1026:"MUNAK",
1028:"SKEL_SOLDIER",
1029:"ISIS",
1030:"ANACONDAQ",
1031:"POPORING",
1032:"VORIT",
1033:"ELDER_WILOW",
1034:"THARA_FROG",
1035:"HUNTER_FLY",
1036:"GHOUL",
1037:"SIDE_WINDER",
1038:"OSIRIS",
1039:"BAPHOMET",
1040:"GOLEM",
1041:"MUMMY",
1042:"STEEL_CHOCHO",
1044:"OBEAUNE",
1045:"MARC",
1046:"DOPPELGANGER",
1047:"PECO_EGG",
1048:"THIEF_BUG_EGG",
1049:"PICKY",
1050:"PICKY_",
1051:"THIEF_BUG",
1052:"ROCKER",
1053:"THIEF_BUG_",
1054:"THIEF_BUG__",
1055:"MUKA",
1056:"SMOKIE",
1057:"YOYO",
1058:"METALLER",
1059:"MISTRESS",
1060:"BIGFOOT",
1061:"NIGHTMARE",
1062:"PORING_",
1063:"LUNATIC",
1064:"MEGALODON",
1065:"STROUF",
1066:"VADON",
1067:"CORNUTUS",
1068:"HYDRA",
1069:"SWORD_FISH",
1070:"KUKRE",
1071:"PIRATE_SKEL",
1072:"KAHO",
1073:"CRAB",
1074:"SHELLFISH",
1076:"SKELETON",
1077:"POISON_SPORE",
1078:"RED_PLANT",
1079:"BLUE_PLANT",
1080:"GREEN_PLANT",
1081:"YELLOW_PLANT",
1082:"WHITE_PLANT",
1083:"SHINING_PLANT",
1084:"BLACK_MUSHROOM",
1085:"RED_MUSHROOM",
1086:"GOLDEN_BUG",
1087:"ORK_HERO2",
1088:"VOCAL",
1089:"TOAD",
1090:"MASTERING",
1091:"DRAGON_FLY",
1092:"VAGABOND_WOLF",
1093:"ECLIPSE",
1094:"AMBERNITE",
1095:"ANDRE",
1096:"ANGELING",
1097:"ANT_EGG",
1098:"ANUBIS",
1099:"ARGIOPE",
1100:"ARGOS",
1101:"BAPHOMET_",
1102:"BATHORY",
1103:"CARAMEL",
1104:"COCO",
1105:"DENIRO",
1106:"DESERT_WOLF",
1107:"DESERT_WOLF_B",
1108:"DEVIACE",
1109:"DEVIRUCHI",
1110:"DOKEBI",
1111:"DRAINLIAR",
1112:"DRAKE",
1113:"DROPS",
1114:"DUSTINESS",
1115:"EDDGA",
1116:"EGGYRA",
1117:"EVIL_DRUID",
1118:"FLORA",
1119:"FRILLDORA",
1120:"GHOSTRING",
1121:"GIEARTH",
1122:"GOBLIN_1",
1123:"GOBLIN_2",
1124:"GOBLIN_3",
1125:"GOBLIN_4",
1126:"GOBLIN_5",
1127:"HODE",
1128:"HORN",
1129:"HORONG",
1130:"JAKK",
1131:"JOKER",
1132:"KHALITZBURG",
1133:"KOBOLD_1",
1134:"KOBOLD_2",
1135:"KOBOLD_3",
1136:"KOBOLD_4",
1137:"KOBOLD_5",
1138:"MAGNOLIA",
1139:"MANTIS",
1140:"MARDUK",
1141:"MARINA",
1142:"MARINE_SPHERE",
1143:"MARIONETTE",
1144:"MARSE",
1145:"MARTIN",
1146:"MATYR",
1147:"MAYA",
1148:"MEDUSA",
1149:"MINOROUS",
1150:"MOONLIGHT",
1151:"MYST",
1152:"ORC_SKELETON",
1153:"ORC_ZOMBIE",
1154:"PASANA",
1155:"PETIT",
1156:"PETIT_",
1157:"PHARAOH",
1158:"PHEN",
1159:"PHREEONI",
1160:"PIERE",
1161:"PLANKTON",
1162:"RAFFLESIA",
1163:"RAYDRIC",
1164:"REQUIEM",
1165:"SAND_MAN",
1166:"SAVAGE",
1167:"SAVAGE_BABE",
1169:"SKEL_WORKER",
1170:"SOHEE",
1174:"STAINER",
1175:"TAROU",
1176:"VITATA",
1177:"ZENORC",
1178:"ZEROM",
1179:"WHISPER",
1180:"NINE_TAIL",
1182:"THIEF_MUSHROOM",
1183:"CHOCHO",
1184:"DR_FABRE",
1185:"whisper_¿µÈ¥°í¸®_",
1186:"WHISPER_BOSS",
1188:"BON_GUN",
1189:"ORC_ARCHER",
1190:"ORC_LORD",
1191:"MIMIC",
1192:"WRAITH",
1193:"ALARM",
1194:"ARCLOUSE",
1195:"RIDEWORD",
1196:"SKEL_PRISONER",
1197:"ZOMBIE_PRISONER",
1198:"DARK_PRIEST",
1199:"PUNK",
1200:"ZHERLTHSH",
1201:"RYBIO",
1202:"PHENDARK",
1203:"MYSTELTAINN",
1204:"TIRFING",
1205:"EXECUTIONER",
1206:"ANOLIAN",
1207:"STING",
1208:"WANDER_MAN",
1209:"CRAMP",
1211:"BRILIGHT",
1212:"IRON_FIST",
1213:"HIGH_ORC",
1214:"CHOCO",
1215:"STEM_WORM",
1216:"PENOMENA",
1219:"KNIGHT_OF_ABYSS",
1220:"DESERT_WOLF",
1221:"SAVAGE",
1229:"FABRE",
1230:"PUPA",
1231:"CREAMY",
1232:"PECOPECO_EGG",
1234:"YOYO",
1235:"SMOKING_ORC",
1236:"ANT_EGG",
1237:"ANDRE",
1238:"PIERE",
1239:"DENIRO",
1240:"PICKY",
1241:"PICKY_",
1242:"MARIN",
1243:"SASQUATCH",
1244:"JAKK_XMAS",
1245:"GOBLINE_XMAS",
1246:"COOKIE_XMAS",
1247:"ANTONIO",
1248:"CRUISER",
1249:"MYSTCASE",
1250:"CHEPET",
1251:"KNIGHT_OF_WINDSTORM",
1252:"GARM",
1253:"GARGOYLE",
1254:"RAGGLER",
1255:"NERAID",
1256:"PEST",
1257:"INJUSTICE",
1258:"GOBLIN_ARCHER",
1259:"GRYPHON",
1260:"DARK_FRAME",
1261:"WILD_ROSE",
1262:"MUTANT_DRAGON",
1263:"WIND_GHOST",
1264:"MERMAN",
1265:"COOKIE",
1266:"ASTER",
1267:"CARAT",
1268:"BLOODY_KNIGHT",
1269:"CLOCK",
1270:"C_TOWER_MANAGER",
1271:"ALLIGATOR",
1272:"DARK_LORD",
1273:"ORC_LADY",
1274:"MEGALITH",
1275:"ALICE",
1276:"RAYDRIC_ARCHER",
1277:"GREATEST_GENERAL",
1278:"STALACTIC_GOLEM",
1279:"TRI_JOINT",
1280:"STEAM_GOBLIN",
1281:"SAGEWORM",
1282:"KOBOLD_ARCHER",
1283:"CHIMERA",
1285:"ARCHER_GUARDIAN",
1286:"KNIGHT_GUARDIAN",
1287:"SOLDIER_GUARDIAN",
1288:"EMPELIUM",
1289:"MAYA_PUPLE",
1290:"SKELETON_GENERAL",
1291:"WRAITH_DEAD",
1292:"MINI_DEMON",
1293:"CREMY_FEAR",
1294:"KILLER_MANTIS",
1295:"OWL_BARON",
1296:"KOBOLD_LEADER",
1297:"ANCIENT_MUMMY",
1298:"ZOMBIE_MASTER",
1299:"GOBLIN_LEADER",
1300:"CATERPILLAR",
1301:"AM_MUT",
1302:"DARK_ILLUSION",
1303:"GIANT_HONET",
1304:"GIANT_SPIDER",
1305:"ANCIENT_WORM",
1306:"LEIB_OLMAI",
1307:"CAT_O_NINE_TAIL",
1308:"PANZER_GOBLIN",
1309:"GAJOMART",
1310:"MAJORUROS",
1311:"GULLINBURSTI",
1312:"TURTLE_GENERAL",
1313:"MOBSTER",
1314:"PERMETER",
1315:"ASSULTER",
1316:"SOLIDER",
1317:"FUR_SEAL",
1318:"HEATER",
1319:"FREEZER",
1320:"OWL_DUKE",
1321:"DRAGON_TAIL",
1322:"SPRING_RABBIT",
1323:"SEE_OTTER",
1324:"TREASUREBOX",
1325:"TREASUREBOX",
1326:"TREASUREBOX",
1327:"TREASUREBOX",
1328:"TREASUREBOX",
1329:"TREASUREBOX",
1330:"TREASUREBOX",
1331:"TREASUREBOX",
1332:"TREASUREBOX",
1333:"TREASUREBOX",
1334:"TREASUREBOX",
1335:"TREASUREBOX",
1336:"TREASUREBOX",
1337:"TREASUREBOX",
1338:"TREASUREBOX",
1339:"TREASUREBOX",
1340:"TREASUREBOX",
1341:"TREASUREBOX",
1342:"TREASUREBOX",
1343:"TREASUREBOX",
1344:"TREASUREBOX",
1345:"TREASUREBOX",
1346:"TREASUREBOX",
1347:"TREASUREBOX",
1348:"TREASUREBOX",
1349:"TREASUREBOX",
1350:"TREASUREBOX",
1351:"TREASUREBOX",
1352:"TREASUREBOX",
1353:"TREASUREBOX",
1354:"TREASUREBOX",
1355:"TREASUREBOX",
1356:"TREASUREBOX",
1357:"TREASUREBOX",
1358:"TREASUREBOX",
1359:"TREASUREBOX",
1360:"TREASUREBOX",
1361:"TREASUREBOX",
1362:"TREASUREBOX",
1363:"TREASUREBOX",
1364:"G_ASSULTER",
1365:"APOCALIPS",
1366:"LAVA_GOLEM",
1367:"BLAZZER",
1368:"GEOGRAPHER",
1369:"GRAND_PECO",
1370:"SUCCUBUS",
1371:"FAKE_ANGEL",
1372:"GOAT",
1373:"LORD_OF_DEATH",
1374:"INCUBUS",
1375:"THE_PAPER",
1376:"HARPY",
1377:"ELDER",
1378:"DEMON_PUNGUS",
1379:"NIGHTMARE_TERROR",
1380:"DRILLER",
1381:"GRIZZLY",
1382:"DIABOLIC",
1383:"EXPLOSION",
1384:"DELETER",
1385:"DELETER_",
1386:"SLEEPER",
1387:"GIG",
1388:"ARCHANGELING",
1389:"DRACULA",
1390:"VIOLY",
1391:"GALAPAGO",
1392:"ROTAR_ZAIRO",
1393:"G_MUMMY",
1394:"G_ZOMBIE",
1395:"CRYSTAL_1",
1396:"CRYSTAL_2",
1397:"CRYSTAL_3",
1398:"CRYSTAL_4",
1399:"EVENT_BAPHO",
1400:"KARAKASA",
1401:"SHINOBI",
1402:"POISON_TOAD",
1403:"ANTIQUE_FIRELOCK",
1404:"MIYABI_NINGYO",
1405:"TENGU",
1406:"KAPHA",
1408:"BLOOD_BUTTERFLY",
1409:"RICE_CAKE_BOY",
1410:"LIVE_PEACH_TREE",
1412:"EVIL_CLOUD_HERMIT",
1413:"WILD_GINSENG",
1415:"BABY_LEOPARD",
1416:"WICKED_NYMPH",
1417:"ZIPPER_BEAR",
1418:"DARK_SNAKE_LORD",
1419:"G_FARMILIAR",
1420:"G_ARCHER_SKELETON",
1421:"G_ISIS",
1422:"G_HUNTER_FLY",
1423:"G_GHOUL",
1424:"G_SIDE_WINDER",
1425:"G_OBEAUNE",
1426:"G_MARC",
1427:"G_NIGHTMARE",
1428:"G_POISON_SPORE",
1429:"G_ARGIOPE",
1430:"G_ARGOS",
1431:"G_BAPHOMET_",
1432:"G_DESERT_WOLF",
1433:"G_DEVIRUCHI",
1434:"G_DRAINLIAR",
1435:"G_EVIL_DRUID",
1436:"G_JAKK",
1437:"G_JOKER",
1438:"G_KHALITZBURG",
1439:"G_HIGH_ORC",
1440:"G_STEM_WORM",
1441:"G_PENOMENA",
1442:"G_SASQUATCH",
1443:"G_CRUISER",
1444:"G_CHEPET",
1445:"G_RAGGLER",
1446:"G_INJUSTICE",
1447:"G_GRYPHON",
1448:"G_DARK_FRAME",
1449:"G_MUTANT_DRAGON",
1450:"G_WIND_GHOST",
1451:"G_MERMAN",
1452:"G_ORC_LADY",
1453:"G_RAYDRIC_ARCHER",
1454:"G_TRI_JOINT",
1455:"G_KOBOLD_ARCHER",
1456:"G_CHIMERA",
1457:"G_MANTIS",
1458:"G_MARDUK",
1459:"G_MARIONETTE",
1460:"G_MATYR",
1461:"G_MINOROUS",
1462:"G_ORC_SKELETON",
1463:"G_ORC_ZOMBIE",
1464:"G_PASANA",
1465:"G_PETIT",
1466:"G_PETIT_",
1467:"G_RAYDRIC",
1468:"G_REQUIEM",
1469:"G_SKEL_WORKER",
1470:"G_ZEROM",
1471:"G_NINE_TAIL",
1472:"G_BON_GUN",
1473:"G_ORC_ARCHER",
1474:"G_MIMIC",
1475:"G_WRAITH",
1476:"G_ALARM",
1477:"G_ARCLOUSE",
1478:"G_RIDEWORD",
1479:"G_SKEL_PRISONER",
1480:"G_ZOMBIE_PRISONER",
1481:"G_PUNK",
1482:"G_ZHERLTHSH",
1483:"G_RYBIO",
1484:"G_PHENDARK",
1485:"G_MYSTELTAINN",
1486:"G_TIRFING",
1487:"G_EXECUTIONER",
1488:"G_ANOLIAN",
1489:"G_STING",
1490:"G_WANDER_MAN",
1491:"G_DOKEBI",
1492:"INCANTATION_SAMURAI",
1493:"DRYAD",
1494:"KIND_OF_BEETLE",
1495:"STONE_SHOOTER",
1497:"WOODEN_GOLEM",
1498:"WOOTAN_SHOOTER",
1499:"WOOTAN_FIGHTER",
1500:"PARASITE",
1502:"PORING_V",
1503:"GIBBET",
1504:"DULLAHAN",
1505:"LOLI_RURI",
1506:"DISGUISE",
1507:"BLOODY_MURDERER",
1508:"QUVE",
1509:"LUDE",
1510:"HYLOZOIST",
1511:"AMON_RA",
1512:"HYEGUN",
1513:"CIVIL_SERVANT",
1514:"DANCING_DRAGON",
1515:"GARM_BABY",
1516:"INCREASE_SOIL",
1517:"LI_ME_MANG_RYANG",
1518:"BACSOJIN",
1519:"CHUNG_E",
1520:"BOILED_RICE",
1521:"G_ALICE",
1522:"G_ANCIENT_MUMMY",
1523:"G_ANTIQUE_FIRELOCK",
1524:"G_BABY_LEOPARD",
1525:"G_BATHORY",
1526:"G_BLOOD_BUTTERFLY",
1527:"G_C_TOWER_MANAGER",
1528:"G_CLOCK",
1529:"G_DARK_SNAKE_LORD",
1530:"G_DRACULA",
1531:"G_EVIL_CLOUD_HERMIT",
1532:"G_EXPLOSION",
1533:"G_FUR_SEAL",
1534:"G_GOBLIN_1",
1535:"G_GOBLIN_2",
1536:"G_GOBLIN_3",
1537:"G_GOBLIN_4",
1538:"G_GOBLIN_5",
1539:"G_GOBLIN_LEADER",
1540:"G_GOLEM",
1541:"G_GREATEST_GENERAL",
1542:"G_INCANTATION_SAMURA",
1543:"G_KAPHA",
1544:"G_KARAKASA",
1545:"G_KOBOLD_1",
1546:"G_KOBOLD_2",
1547:"G_KOBOLD_3",
1548:"G_KOBOLD_LEADER",
1549:"G_LAVA_GOLEM",
1550:"G_LIVE_PEACH_TREE",
1551:"G_MARSE",
1552:"G_MIYABI_NINGYO",
1553:"G_MYST",
1554:"G_NIGHTMARE_TERROR",
1555:"G_PARASITE",
1556:"G_POISON_TOAD",
1557:"G_ROTAR_ZAIRO",
1558:"G_SAND_MAN",
1559:"G_SCORPION",
1560:"G_SHINOBI",
1561:"G_SMOKIE",
1562:"G_SOLDIER_SKELETON",
1563:"G_TENGU",
1564:"G_WICKED_NYMPH",
1565:"G_WILD_GINSENG",
1566:"G_WRAITH_DEAD",
1567:"G_ANCIENT_WORM",
1568:"G_ANGELING",
1569:"G_BLOODY_KNIGHT",
1570:"G_CRAMP",
1571:"G_DEVIACE",
1572:"DROPS",
1573:"G_ELDER",
1574:"G_ELDER_WILOW",
1575:"G_FLORA",
1576:"G_GHOSTRING",
1577:"G_GOBLIN_ARCHER",
1578:"G_HORONG",
1579:"G_HYDRA",
1580:"G_INCUBUS",
1581:"G_VOCAL",
1582:"DEVILING",
1583:"TAO_GUNKA",
1584:"TAMRUAN",
1585:"MIME_MONKEY",
1586:"LEAF_CAT",
1587:"KRABEN",
1588:"ORC_XMAS",
1589:"MANDRAGORA",
1590:"GEOGRAPHER",
1591:"LUNATIC", // "A_LUNATIC"
1592:"MOBSTER", //"A_MOBSTER"
1593:"ANCIENT_MUMMY", //"A_ANCIENT_MUMMY"
1594:"FREEZER",
1595:"MARIN",
1596:"TAMRUAN",
1597:"GARGOYLE",
1598:"BLAZZER",
1599:"WHISPER_BOSS",
1600:"HEATER",
1601:"PERMETER",
1602:"SOLIDER",
1603:"BIGFOOT",
1604:"GIANT_HONET",
1605:"DARK_ILLUSION",
1606:"GARM_BABY",
1607:"GOBLINE_XMAS",
1608:"THIEF_BUG__",
1609:"DANCING_DRAGON",
1610:"MUNAK",
1611:"BON_GUN",
1612:"HYEGUN",
1613:"METALING",
1614:"MINERAL",
1615:"OBSIDIAN",
1616:"PITMAN",
1617:"WASTE_STOVE",
1618:"UNGOLIANT",
1619:"PORCELLIO",
1620:"NOXIOUS",
1621:"VENOMOUS",
1622:"TEDDY_BEAR",
1623:"RSX_0806",
1624:"G_WASTE_STOVE",
1625:"G_PORCELLIO",
1626:"G_DARK_PRIEST",
1627:"ANOPHELES",
1628:"MOLE",
1629:"HILL_WIND",
1630:"BACSOJIN_",
1631:"CHUNG_E",
1632:"GREMLIN",
1633:"BEHOLDER",
1634:"SEYREN",
1635:"EREMES",
1636:"HARWORD",
1637:"MAGALETA",
1638:"SHECIL",
1639:"KATRINN",
1640:"G_SEYREN",
1641:"G_EREMES",
1642:"G_HARWORD",
1643:"G_MAGALETA",
1644:"G_SHECIL",
1645:"G_KATRINN",
1646:"B_SEYREN",
1647:"B_EREMES",
1648:"B_HARWORD",
1649:"B_MAGALETA",
1650:"B_SHECIL",
1651:"B_KATRINN",
1652:"YGNIZEM",
1653:"WHIKEBAIN",
1654:"ARMAIA",
1655:"EREND",
1656:"KAVAC",
1657:"RAWREL",
1658:"B_YGNIZEM",
1659:"G_WHIKEBAIN",
1660:"G_ARMAIA",
1661:"G_EREND",
1662:"G_KAVAC",
1663:"G_RAWREL",
1664:"POTON_CANON",
1665:"POTON_CANON_1",
1666:"POTON_CANON_2",
1667:"POTON_CANON_3",
1668:"ARCHDAM",
1669:"DIMIK",
1670:"DIMIK_1",
1671:"DIMIK_2",
1672:"DIMIK_3",
1673:"DIMIK_4",
1674:"MONEMUS",
1675:"VENATU",
1676:"VENATU_1",
1677:"VENATU_2",
1678:"VENATU_3",
1679:"VENATU_4",
1680:"HILL_WIND_1",
1681:"GEMINI",
1682:"REMOVAL",
1683:"G_POTON_CANON",
1684:"G_ARCHDAM",
1685:"APOCALIPS_H",
1686:"ORC_BABY",
1687:"GREEN_IGUANA",
1688:"LADY_TANEE",
1689:"G_BACSOJIN",
1690:"G_SPRING_RABBIT",
1691:"KRABEN",
1692:"BREEZE",
1693:"PLASMA_Y",
1694:"PLASMA_R",
1695:"PLASMA_G",
1696:"PLASMA_P",
1697:"PLASMA_B",
1698:"DEATHWORD",
1699:"ANCIENT_MIMIC",
1700:"OBSERVATION",
1701:"SHELTER",
1702:"RETRIBUTION",
1703:"SOLACE",
1704:"THA_ODIUM",
1705:"THA_DESPERO",
1706:"THA_MAERO",
1707:"THA_DOLOR",
1708:"THANATOS",
1709:"THA_ODIUM",
1710:"THA_DESPERO",
1711:"THA_MAERO",
1712:"THA_DOLOR",
1713:"ACIDUS",
1714:"FERUS",
1715:"NOVUS",
1716:"ACIDUS_",
1717:"FERUS_",
1718:"NOVUS_",
1719:"DETALE",
1720:"HYDRO",
1721:"DRAGON_EGG",
1722:"JAKK",
1723:"SHECIL",
1724:"POTON_CANON",
1725:"PORING",
1726:"LUNATIC",
1727:"SAVAGE_BABE",
1728:"DESERT_WOLF_B",
1729:"BAPHOMET_",
1730:"DEVIRUCHI",
1731:"DOPPELGANGER",
1732:"TREASURE_BOX",
1733:"KIEL",
1734:"KIEL_",
1735:"ALICEL",
1736:"ALIOT",
1737:"ALIZA",
1738:"CONSTANT",
1739:"ALICEL",
1740:"ALIOT",
1741:"COOKIE_XMAS",
1742:"CARAT",
1743:"MYSTCASE",
1744:"WILD_ROSE",
1745:"G_CONSTANT",
1746:"ALIZA",
1747:"SNAKE",
1748:"ANACONDAQ",
1749:"MEDUSA",
1750:"RED_PLANT",
1751:"RANDGRIS",
1752:"SKOGUL",
1753:"FRUS",
1754:"SKEGGIOLD",
1755:"SKEGGIOLD_",
1756:"HYDRO",
1757:"ACIDUS",
1758:"FERUS",
1759:"ACIDUS_",
1760:"FERUS_",
1761:"SKOGUL",
1762:"FRUS",
1763:"SKEGGIOLD",
1764:"SKEGGIOLD_",
1765:"G_RANDGRIS",
1766:"EM_ANGELING",
1767:"EM_DEVILING",
1768:"GLOOMUNDERNIGHT",
1769:"AGAV",
1770:"ECHIO",
1771:"VANBERK",
1772:"ISILLA",
1773:"HODREMLIN",
1774:"SEEKER",
1775:"SNOWIER",
1776:"SIROMA",
1777:"ICE_TITAN",
1778:"GAZETI",
1779:"KTULLANUX",
1780:"MUSCIPULAR",
1781:"DROSERA",
1782:"ROWEEN",
1783:"GALION",
1784:"STAPO",
1785:"ATROCE",
1786:"G_AGAV",
1787:"G_ECHIO",
1788:"G_ICE_TITAN",
1789:"ICEICLE",
1790:"G_RAFFLESIA",
1791:"G_GALION",
1792:"SOCCER_BALL",
1793:"G_MEGALITH",
1794:"G_ROWEEN",
1795:"BLOODY_KNIGHT_",
1796:"AUNOE",
1797:"FANAT",
1798:"TREASURE_BOX_",
1799:"B_SEYREN_",
1800:"B_EREMES_",
1801:"B_HARWORD_",
1802:"B_MAGALETA_",
1803:"B_SHECIL_",
1804:"B_KATRINN_",
1805:"G_SEYREN_",
1806:"G_EREMES_",
1807:"G_HARWORD_",
1808:"G_MAGALETA_",
1809:"G_SHECIL_",
1810:"G_KATRINN_",
1811:"G_SMOKIE_",
1812:"LUDE",
1813:"HYDRO",
1814:"MOON",
1815:"EVENT_RICECAKE",
1816:"EVENT_GOURD",
1817:"DETALE",
1818:"ALARM",
1819:"BATHORY",
1820:"BIGFOOT",
1821:"DESERT_WOLF",
1822:"DEVIRUCHI",
1823:"FREEZER",
1824:"GARM_BABY",
1825:"GOBLINE_XMAS",
1826:"MYST",
1827:"SASQUATCH",
1828:"GULLINBURSTI",
1829:"SWORD_GUARDIAN",
1830:"BOW_GUARDIAN",
1831:"SALAMANDER",
1832:"IFRIT",
1833:"KASA",
1834:"SALAMANDER",
1835:"KASA",
1836:"MAGMARING",
1837:"IMP",
1838:"KNOCKER",
1839:"BYORGUE",
1840:"GOLDEN_SAVAGE",
1841:"SNAKE",
1842:"ANACONDAQ",
1843:"SIDE_WINDER",
1844:"ISIS",
1845:"TREASUREBOX",
1846:"DREAMMETAL",
1847:"PORING",
1848:"BAPHOMET",
1849:"OSIRIS",
1850:"ORk_HERO",
1851:"MOBSTER",
1852:"ANGELING",
1853:"DEVILING",
1854:"MUKA",
1855:"POISON_SPORE",
1856:"MAGNOLIA",
1857:"MARIN",
1858:"PLANKTON",
1859:"MANDRAGORA",
1860:"COCO",
1861:"CHOCO",
1862:"MARTIN",
1863:"SPRING_RABBIT",
1864:"ZOMBIE_SLAUGHTER",
1865:"RAGGED_ZOMBIE",
1866:"HELL_POODLE",
1867:"BANSHEE",
1868:"G_BANSHEE",
1869:"FLAME_SKULL",
1870:"NECROMANCER",
1871:"FALLINGBISHOP",
1872:"BEELZEBUB_FLY",
1873:"BEELZEBUB",
1874:"BEELZEBUB_",
1875:"TRISTAN_3RD",
1876:"E_LORD_OF_DEATH",
1877:"CRYSTAL_5",
1878:"SHINING_PLANT",
1879:"ECLIPSE_P",
1880:"WOOD_GOBLIN",
1881:"LES",
1882:"VAVAYAGA",
1883:"UZHAS",
1884:"MAVKA",
1885:"GOPINICH",
1886:"G_MAVKA",
1887:"FREEZER_R",
1888:"GARM_BABY_R",
1889:"GARM_R",
1890:"GOPINICH_R",
1891:"G_RANDGRIS_",
1892:"G_LOLI_RURI",
1893:"G_KNIGHT_OF_ABYSS",
1894:"POURING",
1895:"EVENT_SEYREN",
1896:"EVENT_KATRINN",
1897:"EVENT_BAPHOMET_",
1898:"EVENT_ZOMBIE",
1899:"SWORD_GUARDIAN_",
1900:"BOW_GUARDIAN_",
1901:"E_CONDOR",
1902:"E_TREASURE1",
1903:"E_TREASURE2",
1904:"BOMBPORING",
1905:"BARRICADE",
1906:"BARRICADE_",
1907:"S_EMPEL_1",
1908:"S_EMPEL_2",
1909:"OBJ_A",
1910:"OBJ_B",
1911:"OBJ_NEUTRAL",
1912:"OBJ_FLAG_A",
1913:"OBJ_FLAG_B",
1914:"OBJ_A2",
1915:"OBJ_B2",
1916:"MOROCC",
1917:"MOROCC_",
1918:"MOROCC_1",
1919:"MOROCC_2",
1920:"MOROCC_3",
1921:"MOROCC_4",
1922:"G_MOROCC_1",
1923:"G_MOROCC_2",
1924:"G_MOROCC_3",
1925:"G_MOROCC_4",
1926:"JAKK",
1927:"WHISPER_H",
1928:"DEVIRUCHI_H",
1929:"BAPHOMET_I",
1930:"PIAMETTE",
1931:"WISH_MAIDEN",
1932:"GARDEN_KEEPER",
1933:"GARDEN_WATCHER",
1934:"BLUE_FLOWER",
1935:"RED_FLOWER",
1936:"YELL_FLOWER",
1937:"CONSTANT_",
1938:"TREASURE_BOX41",
1939:"TREASURE_BOX42",
1940:"TREASURE_BOX43",
1941:"TREASURE_BOX44",
1942:"TREASURE_BOX45",
1943:"TREASURE_BOX46",
1944:"TREASURE_BOX47",
1945:"TREASURE_BOX48",
1946:"TREASURE_BOX49",
1947:"PIAMETTE_",
1948:"G_YGNIZEM",
1949:"B_S_GUARDIAN",
1950:"B_B_GUARDIAN",
1951:"CRYSTAL_6",
1952:"CRYSTAL_7",
1953:"CRYSTAL_8",
1954:"CRYSTAL_9",
1955:"TREASURE_BOX_I",
1956:"NAGHT_SIEGER",
1957:"ENTWEIHEN",
1958:"G_ENTWEIHEN_R",
1959:"G_ENTWEIHEN_H",
1960:"G_ENTWEIHEN_M",
1961:"G_ENTWEIHEN_S",
1962:"ANTONIO_",
1963:"P_CHUNG_E",
1964:"NIGHTMARE",
1965:"WILD_ROSE",
1966:"DOPPELGANGER",
1967:"YGNIZEM",
1968:"STROUF",
1969:"MARC",
1970:"OBEAUNE",
1971:"VADON",
1972:"MARINA",
1973:"PORING",
1974:"BANSHEE_MASTER",
1975:"BEHOLDER_MASTER",
1976:"COBALT_MINERAL",
1977:"HEAVY_METALING",
1978:"HELL_APOCALIPS",
1979:"ZAKUDAM",
1980:"KUBLIN",
1981:"I_HIGH_ORC",
1982:"I_ORC_ARCHER",
1983:"I_ORC_SKELETON",
1984:"I_ORC_LADY",
1985:"DANDELION",
1986:"TATACHO",
1987:"CENTIPEDE",
1988:"NEPENTHES",
1989:"HILLSRION",
1990:"HARDROCK_MOMMOTH",
1991:"TENDRILRION",
1992:"CORNUS",
1993:"NAGA",
1994:"LUCIOLA_VESPA",
1995:"PINGUICULA",
1997:"G_TATACHO",
1998:"G_HILLSRION",
1999:"CENTIPEDE_LARVA",
2000:"M_GAMEMASTER",
2001:"F_GAMEMASTER",
2002:"T_SPRING_RABBIT",
2003:"T_BACSOJIN",
2004:"T_WICKED_NYMPH",
2005:"T_PLASMA_B",
2006:"T_PLASMA_P",
2007:"T_PLASMA_R",
2008:"WOOMAWANG",
2009:"WOOMAWANG_",
2010:"G_MAJORUROS",
2011:"GHOUL",
2012:"ZOMBIE",
2013:"DRACO",
2014:"DRACO_EGG",
2015:"PINGUICULA_D",
2016:"AQUA_ELEMENTAL",
2017:"RATA",
2018:"DUNEYRR",
2019:"ANCIENT_TREE",
2020:"RHYNCHO",
2021:"PHYLLA",
2022:"S_NYDHOG",
2023:"DARK_SHADOW",
2024:"BRADIUM_GOLEM",
2025:"MYSTCASE",
2026:"DANDELION",
2027:"G_DARK_SHADOW",
2030:"HIDEN_PRIEST",
2031:"DANDELION",
2032:"GUARDIAN_FOREST",
2033:"GOLDEN_TULIP",
2034:"M_DESERT_WOLF_B",
2035:"NIHILITY_ZEM",
2036:"VALKYRIE_N",
2037:"VALKYRIE_A",
2038:"VALKYRIE_B",
2039:"EXECUTIONER_R",
2040:"TIRFING_R",
2041:"MYSTELTAINN",
2042:"SILVERSNIPER",
2043:"MAGICDECOY_FIRE",
2044:"MAGICDECOY_WATER",
2045:"MAGICDECOY_EARTH",
2046:"MAGICDECOY_WIND",
2047:"NAGA",
2048:"PINGUICULA_D",
2049:"BRADIUM_GOLEM",
2050:"AQUA_ELEMENTAL",
2052:"DARKLORD",
2057:"CRAMP",
2058:"MIMIC",
2059:"DISGUISE",
2060:"ALICE",
2066:"ANOPHELES",
2067:"ANOPHELES",
2068:"BOITATA",
2069:"IARA",
2070:"PIRANHA",
2071:"HEADLESS_MULE",
2072:"JAGUAR",
2073:"TOUCAN",
2074:"CURUPIRA",
2075:"E_VADON_X",
2076:"S_WIND_GHOST",
2077:"S_SKOGUL",
2078:"S_SUCCUBUS",
2079:"CRYSTAL_H",
2080:"CRYSTAL_L",
2081:"E_HYDRA",
2082:"G_PIRANHA",
2083:"HORN_SCARABA",
2084:"HORN_SCARABA2",
2085:"ANTLER_SCARABA",
2086:"RAKE_SCARABA",
2087:"QUEEN_SCARABA",
2088:"HORN_SCARABA_EGG",
2089:"HORN_SCARABA2_EGG",
2090:"ANTLER_SCARABA_EGG",
2091:"RAKE_SCARABA_EGG",
2092:"DOLOMEDES",
2093:"BOTARING",
2094:"ORK_HERO2",
2095:"EDDGA",
2096:"OSIRIS2",
2097:"DRACULA",
2098:"DOPPELGANGER",
2099:"MISTRESS",
2100:"BAPHOMET2",
2101:"LORD_OF_DEATH2",
2102:"DARK_LORD",
2103:"KTULLANUX",
2104:"DARK_SNAKE_LORD",
2105:"TURTLE_GENERAL",
2106:"APOCALIPS_H",
2107:"FALLINGBISHOP",
2108:"GLOOMUNDERNIGHT",
2109:"RANDGRIS",
2110:"IFRIT",
2111:"HARWORD",
2112:"SEYREN",
2113:"EREMES",
2126:"M_ANOPHELES",
2127:"M_HORNET",
2128:"M_HORNET2",
2129:"M_LUCIOLA_VESPA",
2130:"M_LUCIOLA_VESPA2",
2131:"LOST_DRAGON",
2132:"POM_SPIDER",
2133:"ANGRA_MANTIS",
2134:"PARUS",
2135:"CREEPER",
2136:"LITTLE_FATUM",
2137:"MIMING",
2138:"NYDHOG_MEMORY1_1",
2139:"NYDHOG_MEMORY1_2",
2140:"NYDHOG_MEMORY2_1",
2141:"NYDHOG_MEMORY2_2",
2142:"NYDHOG_MEMORY3_1",
2143:"NYDHOG_MEMORY3_2",
2144:"G_ANTLER_SCARABA",
2145:"G_RAKE_SCARABA",
2146:"G_S_NYDHOG",
2147:"E_WHITE_PLANT",
2148:"E_BLUE_PLANT",
2149:"E_SAVAGE_BABE",
2150:"WATERMELON",
2151:"ALNOLDI",
2152:"COMODO",
2153:"CENDRAWASIH",
2154:"BANASPATY",
2155:"BUTOIJO",
2156:"LEAK",
2157:"G_BANASPATY",
2158:"S_HORNET",
2159:"S_GIANT_HORNET",
2160:"S_LUCIOLA_VESPA",
2161:"I_HORN_SCARABA",
2162:"I_HORN_SCARABA2",
2163:"I_ANTLER_SCARABA",
2164:"I_RAKE_SCARABA",
2165:"I_QUEEN_SCARABA",
2166:"I_HORN_SCARABA_EGG",
2167:"I_HORN_SCARABA2_EGG",
2168:"I_ANTLER_SCARABA_EGG",
2169:"I_RAKE_SCARABA_EGG",
2170:"I_G_ANTLER_SCARABA",
2171:"I_G_RAKE_SCARABA",
2172:"I_G_HORN_SCARABA",
2173:"I_G_HORN_SCARABA2",
2174:"VADON",
2175:"MARSE",
2176:"CRAB",
2177:"CORNUTUS",
2178:"SHELLFISH",
2179:"KUKRE",
2180:"STROUF",
2181:"SWORD_FISH",
2182:"MARC",
2183:"ANOLIAN",
2184:"OBEAUNE",
2185:"KAPHA",
2186:"COELACANTH_N_E",
2187:"COELACANTH_N_A",
2188:"COELACANTH_N_M",
2189:"COELACANTH_H_M",
2190:"COELACANTH_H_A",
2191:"MD_SEAWEED",
2192:"MD_OCTOPUS",
2193:"MD_OCTOPUS_LEG",
2194:"MD_GIANT_OCTOPUS",
2195:"MD_G_KUKRE",
2196:"MD_G_STROUF",
2197:"RED_ERUMA",
2198:"KING_DRAMOH",
2199:"SIORAVA",
2200:"J_TAINI",
2201:"SROPHO",
2202:"KRAKEN",
2203:"POT_DOFLE",
2204:"SEDORA",
2206:"KRAKEN_LEG",
2208:"WILD_RIDER",
2209:"THIEF_BUG",
2210:"XMAS_LUNATIC",
2211:"TEDDY_BEAR",
2212:"KNIGHT_OF_WINDSTORM",
2213:"WANDER_MAN",
2214:"WICKED_NYMPH",
2215:"KASA",
2216:"SALAMANDER",
2217:"TEDDY_BEAR",
2218:"OCTOPUS_LEG",
2219:"GIANT_OCTOPUS",
2220:"QUVE",
2221:"RANDEL",
2222:"FLAMEL",
2223:"CELIA",
2224:"CHEN",
2225:"GERTIE",
2226:"ALPHOCCIO",
2227:"TRENTINI",
2228:"RANDEL",
2229:"FLAMEL",
2230:"CELIA",
2231:"CHEN",
2232:"GERTIE",
2233:"ALPHOCCIO",
2234:"TRENTINI",
2235:"RANDEL",
2236:"FLAMEL",
2237:"CELIA",
2238:"CHEN",
2239:"GERTIE",
2240:"ALPHOCCIO",
2241:"TRENTINI",
2242:"DESERT_WOLF",
2243:"DESERT_WOLF_B",
2244:"QUEST_CHEN",
2245:"EXP_TEST",
2246:"WOOTAN_FIGHTER",
2247:"INCREASE_SOIL",
2248:"GOLDPORING",
2249:"PYURIEL",
2250:"LORA",
2251:"GIOIA",
2252:"ELVIRA",
2253:"DAEHYON",
2254:"SOHEON",
2255:"KADES",
2256:"RUDO",
2257:"I_PIAMETTE",
2258:"I_PIAMETTE_",
2259:"I_GARDEN_KEEPER",
2260:"G_GARDEN_KEEPER",
2261:"I_GARDEN_WATCHER",
2262:"G_GARDEN_WATCHER",
2263:"I_WISH_MAIDEN",
2264:"I_ARMAIA",
2265:"I_ARMAIA_",
2266:"I_EREND",
2267:"I_EREND_",
2268:"I_KAVAC",
2269:"I_KAVAC_",
2270:"I_RAWREL",
2271:"I_RAWREL_",
2272:"I_WHIKEBAIN",
2273:"I_WHIKEBAIN_",
2274:"I_YGNIZEM",
2275:"I_YGNIZEM_",
2276:"I_DOPPELGANGER",
2277:"G_LORA",
2278:"G_ELVIRA",
2279:"G_SOHEON",
2280:"G_RUDO",
2281:"GLD_DARK_SHADOW",
2282:"GLD_DARK_FRAME",
2283:"GLD_DARK_PRIEST",
2284:"GLD_KOBOLD_1",
2285:"GLD_KOBOLD_2",
2286:"GLD_KOBOLD_3",
2287:"GLD_KOBOLD_ARCHER",
2288:"GLD_TREASURE",
2289:"FABRE",
2290:"THIEF_BUG",
2291:"HORNET",
2292:"HORN",
2293:"KIND_OF_BEETLE",
2294:"ARGIOPE",
2295:"GIANT_SPIDER",
2296:"KILLER_MANTIS",
2297:"GIANT_HONET",
2298:"DRAGON_TAIL",
2299:"STAINER",
2300:"CHOCHO",
2301:"STEEL_CHOCHO",
2302:"HUNTER_FLY",
2303:"MAYA",
2304:"QUEEN_SCARABA",
2305:"UNGOLIANT",
2306:"GOLDEN_BUG",
2307:"MISTRESS",
2308:"KO_KAGE",
2309:"BUNGISNGIS",
2310:"ENGKANTO",
2311:"MANANANGGAL",
2312:"MANGKUKULAM",
2313:"TIKBALANG",
2314:"TIYANAK",
2315:"WAKWAK",
2316:"JEJELING",
2317:"BANGUNGOT_1",
2318:"BANGUNGOT_2",
2319:"BUWAYA",
2320:"BAKONAWA_1",
2321:"BAKONAWA_2",
2322:"BAKONAWA_3",
2323:"EVENT_BOMB",
2324:"EVENT_RANGE",
2325:"BAPHOMET_",
2326:"GALAPAGO",
2327:"BANGUNGOT_3",
2328:"DRUM",
2329:"BUWAYA_EGG",
2330:"BUWAYA_SLAVE",
2331:"SEAW",
2332:"BUWAYA_GHOST",
2333:"BUWAYA_WEAK",
2334:"WAKWAK",
2335:"TREASURE",
2336:"DOMOVOI",
2337:"HIDDEN_MOB",
2338:"MANANANGGAL",
2339:"MANGKUKULAM",
2340:"TIYANAK",
2341:"RWC_BOSS2011",
2342:"DIABOLIC",
2343:"HIDDEN_MOB_W",
2344:"WISH_MAIDEN",
2345:"ZHERLTHSH",
2346:"KTULLANUX",
2347:"EDDGA",
2348:"CIVIL_SERVANT",
2349:"LOLI_RURI",
2350:"SEDORA",
2351:"CHEPET",
2352:"RSX_0805",
2353:"MINOROUS",
2354:"MUMMY",
2355:"VORIT",
2356:"MIMIC",
2357:"MIMIC",
2358:"ARCLOUSE",
2359:"ARCLOUSE",
2360:"ANCIENT_MUMMY",
2361:"ANCIENT_MUMMY",
2362:"AMON_RA",
2363:"MENBLATT",
2364:"PETAL",
2365:"CENERE",
2366:"ANTIQUE_BOOK",
2367:"LICHTERN_B",
2368:"LICHTERN_Y",
2369:"LICHTERN_R",
2370:"LICHTERN_G",
2371:"FAITHFUL_MANAGER",
2372:"SOIL",
2373:"ROCK",
2374:"THICKET",
2375:"MOROCC_4_142",
2376:"MOROCC_2_142",
2377:"NOVUS_",
2378:"MER_ANTLER_SCARABA",
2379:"XMAS_SMOKEY_SOCK",
2380:"XMAS_SMOKEY_GIFT",
2398:"LITTLE_PORING",
2401:"PORING",
2402:"POPORING_IMMUNE_M",
2403:"POPORING_IMMUNE_A",
2404:"DEAD_PLANKTON",
2405:"WEAK_SKELETON",
2406:"WEAK_SKEL_SOLDIER",
2407:"SAILOR_SKELETON",
2408:"DUMMY_10",
2409:"DUMMY_50",
2410:"DUMMY_100",
2411:"DUMMY_150",
2413:"DUMMY_10_FIRE",
2415:"L_SEYREN",
2416:"L_EREMES",
2417:"L_HARWORD",
2418:"L_SHECIL",
2419:"L_KATRINN",
2420:"L_MAGALETA",
2421:"L_YGNIZEM",
2422:"L_WHIKEBAIN",
2423:"L_ARMAIA",
2424:"L_KAVAC",
2425:"L_DANCER",
2426:"L_RAWREL",
2427:"L_EREND",
2428:"SEYREN",
2429:"EREMES",
2430:"HARWORD",
2431:"SHECIL",
2432:"KATRINN",
2433:"MAGALETA",
2434:"YGNIZEM",
2435:"WHIKEBAIN",
2436:"ARMAIA",
2437:"KAVAC",
2438:"DANCER",
2439:"RAWREL",
2440:"EREND",
2441:"NOVICE",
2442:"SUPERNOVICE",
2443:"AIRA",
2444:"KULUNA",
2445:"MALLINA",
2446:"EZELLA",
2447:"LUNE",
2448:"MORIN",
2449:"NASARIN",
2450:"THIEF_PORING",
2451:"BABY_STRANGE",
2452:"TREASUREBOX",
2453:"TREASUREBOX",
2454:"TREASUREBOX",
2455:"TREASUREBOX",
2456:"TREASUREBOX",
2457:"TREASUREBOX",
2458:"TREASUREBOX",
2459:"TREASUREBOX",
2460:"TREASUREBOX",
2461:"TREASUREBOX",
2462:"TREASUREBOX",
2464:"ZOMBIE",
2465:"WRAITH",
2466:"GHOUL",
2467:"ARCLOUSE",
2468:"RAYDRIC",
2469:"RAYDRIC_ARCHER",
2470:"KNIGHT_OF_ABYSS",
2471:"KHALITZBURG",
2472:"BLOODY_KNIGHT",
2473:"MG_M_UNDEAD_KNIGHT",
2474:"MG_F_UNDEAD_KNIGHT",
2475:"MG_CORRUPTION_ROOT",
2476:"MG_AMDARAIS",
2477:"WANDER_MAN",
2478:"RIDEWORD",
2479:"MIMIC",
2480:"EVIL_DRUID",
2481:"WRAITH_DEAD",
2483:"BAPHOMET",
2484:"BAPHOMET_",
2485:"CHIMERA",
2528:"FACEWORM",
2529:"FACEWORM_QUEEN",
2530:"FACEWORM_DARK",
2531:"VENOM_BUG",
2532:"FACEWORM_QUEEN_R",
2533:"FACEWORM_QUEEN_G",
2534:"FACEWORM_QUEEN_B",
2535:"FACEWORM_QUEEN_Y",
2536:"HIDDEN_MOB3",
2537:"HIDDEN_MOB4",
2539:"HIDDEN_MOB5",
2540:"FACEWORM_EGG",
2541:"FACEWORM_LARVA",
2542:"IRENE_ELDER",
2543:"PAYONSOLDIER",
2544:"PAYONSOLDIER2",
2545:"GUARDDOG",
2546:"GUARDDOG2",
2549:"GEFFEN_MAGE_1",
2550:"GEFFEN_MAGE_2",
2551:"GEFFEN_MAGE_3_1",
2552:"GEFFEN_MAGE_3_2",
2553:"GEFFEN_MAGE_3_3",
2554:"GEFFEN_MAGE_4",
2555:"GEFFEN_MAGE_5",
2556:"GEFFEN_MAGE_6",
2557:"GEFFEN_MAGE_7",
2558:"GEFFEN_MAGE_8",
2559:"GEFFEN_MAGE_9",
2560:"GEFFEN_MAGE_10",
2561:"GEFFEN_MAGE_11",
2562:"GEFFEN_MAGE_12",
2563:"FEI_KANABIAN",
2564:"GEFFEN_FENRIR",
2565:"ALPHONSE",
2566:"ALPHONSE_JR",
2567:"E_GEFFEN_MAGE_3_2",
2568:"E_GEFFEN_MAGE_3_3",
2569:"ANOPHELES",
2570:"BREEZE",
2571:"BUTOIJO",
2572:"CARAMEL",
2573:"CHOCHO",
2574:"CIVIL_SERVANT",
2575:"COCO",
2576:"CREAMY",
2577:"FABRE",
2578:"HORN",
2579:"HYLOZOIST",
2580:"KAHO",
2581:"LUDE",
2582:"LUNATIC",
2583:"MARTIN",
2584:"MINERAL",
2585:"MOLE",
2586:"NERAID",
2587:"OBSIDIAN",
2588:"PITMAN",
2589:"POPORING",
2590:"ROCKER",
2591:"SAVAGE",
2592:"SIORAVA",
2593:"SIROMA",
2594:"SNOWIER",
2595:"STAINER",
2596:"STAPO",
2597:"STEEL_CHOCHO",
2598:"UNGOLIANT",
2599:"WILD_RIDER",
2600:"WOLF",
2601:"YOYO",
2602:"ZIPPER_BEAR",
2603:"ZOMBIE_SLAUGHTER",
2604:"ZOMBIE_PRISONER",
2605:"ZOMBIE_MASTER",
2606:"ZOMBIE",
2607:"ZAKUDAM",
2608:"YOYO",
2609:"YOYO",
2610:"WORM_TAIL",
2611:"WOOTAN_FIGHTER",
2612:"WOOD_GOBLIN",
2613:"WOLF",
2614:"WIND_GHOST",
2615:"WILOW",
2616:"WILD_ROSE",
2617:"WICKED_NYMPH",
2618:"WHISPER",
2619:"WEAK_SKELETON",
2620:"WANDER_MAN",
2621:"VIOLY",
2622:"VIOLY",
2623:"VIOLY",
2624:"VENOMOUS",
2625:"VENATU_1",
2626:"VAVAYAGA",
2627:"VANBERK",
2628:"VADON",
2629:"UNGOLIANT",
2630:"TOUCAN",
2631:"TIYANAK",
2632:"THIEF_BUG",
2633:"THIEF_BUG",
2634:"THIEF_BUG",
2635:"THARA_FROG",
2636:"TEDDY_BEAR",
2637:"TATACHO",
2638:"TAROU",
2639:"TAMRUAN",
2640:"STING",
2641:"STEM_WORM",
2642:"STEEL_CHOCHO",
2643:"STAPO",
2644:"STALACTIC_GOLEM",
2645:"STAINER",
2646:"SPORE",
2647:"SOLIDER",
2648:"SKEL_SOLDIER",
2649:"SKEL_SOLDIER",
2650:"SOLACE",
2651:"SOHEE",
2652:"SNOWIER",
2653:"SNAKE",
2654:"SMOKIE",
2655:"SLEEPER",
2656:"SLEEPER",
2657:"SKOGUL",
2658:"SKELETON_GENERAL",
2659:"SKELETON_GENERAL",
2660:"SKEL_WORKER",
2661:"SIROMA",
2662:"SIDE_WINDER",
2663:"SIDE_WINDER",
2664:"SHINOBI",
2665:"SHELTER",
2666:"SHELLFISH",
2667:"SHECIL",
2668:"SEE_OTTER",
2669:"SEDORA",
2670:"SCORPION",
2671:"SAVAGE_BABE",
2672:"SAVAGE",
2673:"SAVAGE",
2674:"SAND_MAN",
2675:"SALAMANDER",
2676:"SAILOR_SKELETON",
2677:"ROWEEN",
2678:"RODA_FROG",
2679:"RODA_FROG",
2680:"ROCKER",
2681:"RIDEWORD",
2682:"RIDEWORD",
2683:"RICE_CAKE_BOY",
2684:"RETRIBUTION",
2685:"RETRIBUTION",
2686:"RETRIBUTION",
2687:"REQUIEM",
2688:"REMOVAL",
2689:"RED_ERUMA",
2690:"RAYDRIC",
2691:"RAYDRIC",
2692:"RAWREL",
2693:"RAKE_SCARABA",
2694:"RAGGLER",
2695:"RAFFLESIA",
2696:"PORING",
2697:"PORING",
2698:"PORING",
2699:"PORING",
2700:"PORCELLIO",
2701:"POPORING",
2702:"POPORING",
2703:"POPORING",
2704:"POISON_TOAD",
2705:"POISON_SPORE",
2706:"PLASMA_Y",
2707:"PLANKTON",
2708:"PITMAN",
2709:"PIRANHA",
2710:"PINGUICULA_D",
2711:"PINGUICULA",
2712:"PICKY_",
2713:"PHEN",
2714:"PETIT",
2715:"PETIT",
2716:"PENOMENA",
2717:"PENOMENA",
2718:"PECOPECO",
2719:"PASANA",
2720:"PARASITE",
2721:"OWL_DUKE",
2722:"ORK_WARRIOR",
2723:"ORC_ZOMBIE",
2724:"ORC_SKELETON",
2725:"ORC_LADY",
2726:"OBSERVATION",
2727:"NOXIOUS",
2728:"NOVUS",
2729:"NOVUS",
2730:"NOVUS",
2731:"NOVUS",
2732:"NIGHTMARE_TERROR",
2733:"WRAITH_DEAD",
2734:"WANDER_MAN",
2735:"NEPENTHES",
2736:"NECROMANCER",
2737:"MYSTCASE",
2738:"MUSCIPULAR",
2739:"MUMMY",
2740:"MUMMY",
2741:"MUKA",
2742:"MOROCC_1",
2743:"MOROCC_1",
2744:"MOROCC_1",
2745:"MOLE",
2746:"MIYABI_NINGYO",
2747:"MINOROUS",
2748:"MINOROUS",
2749:"MINOROUS",
2750:"MINERAL",
2751:"MIMING",
2752:"MIMIC",
2753:"MIMIC",
2754:"METALLER",
2755:"METALING",
2756:"METALING",
2757:"MERMAN",
2758:"MENBLATT",
2759:"MEDUSA",
2760:"MARTIN",
2761:"MARIONETTE",
2762:"MARIN",
2763:"MARDUK",
2764:"MANTIS",
2765:"MANDRAGORA",
2766:"MANANANGGAL",
2767:"MAJORUROS",
2768:"MAGNOLIA",
2769:"MAGMARING",
2770:"LUNATIC",
2771:"LUNATIC",
2772:"LUDE",
2773:"LUCIOLA_VESPA",
2774:"LOLI_RURI",
2775:"LIVE_PEACH_TREE",
2776:"LITTLE_PORING",
2777:"LITTLE_FATUM",
2778:"LI_ME_MANG_RYANG",
2779:"LES",
2780:"LEIB_OLMAI",
2781:"LEAF_CAT",
2782:"L_WHIKEBAIN",
2783:"L_EREMES",
2784:"KOBOLD_ARCHER",
2785:"KOBOLD_1",
2786:"KNOCKER",
2787:"KIND_OF_BEETLE",
2788:"KASA",
2789:"KARAKASA",
2790:"ISIS",
2791:"ISILLA",
2792:"INJUSTICE",
2793:"INCREASE_SOIL",
2794:"ICE_TITAN",
2795:"IARA",
2796:"HYEGUN",
2797:"HUNTER_FLY",
2798:"HORNET",
2799:"HORN_SCARABA",
2800:"HORN",
2801:"HODREMLIN",
2802:"HODE",
2803:"HILL_WIND_1",
2804:"HILL_WIND_1",
2805:"HIGH_ORC",
2806:"HARPY",
2807:"HARPY",
2808:"GREEN_IGUANA",
2809:"GREATEST_GENERAL",
2810:"GRAND_PECO",
2811:"GRAND_PECO",
2812:"GOLEM",
2813:"GOBLIN_1",
2814:"GOBLIN_1",
2815:"GOAT",
2816:"GOAT",
2817:"GLD_KOBOLD_2",
2818:"GLD_KOBOLD_2",
2819:"GLD_DARK_SHADOW",
2820:"GLD_DARK_SHADOW",
2821:"GIANT_HONET",
2822:"GHOUL",
2823:"GHOUL",
2824:"GEOGRAPHER",
2825:"GEOGRAPHER",
2826:"GARGOYLE",
2827:"GARGOYLE",
2828:"GALION",
2829:"FUR_SEAL",
2830:"FREEZER",
2831:"FREEZER",
2832:"FERUS_",
2833:"FARMILIAR",
2834:"FAKE_ANGEL",
2835:"FABRE",
2836:"FABRE",
2837:"EXPLOSION",
2838:"EVIL_DRUID",
2839:"ELDER_WILOW",
2840:"ELDER_WILOW",
2841:"ECHIO",
2842:"DUSTINESS",
2843:"DRYAD",
2844:"DROSERA",
2845:"DROPS",
2846:"DRILLER",
2847:"DRAINLIAR",
2848:"DRAGON_TAIL",
2849:"DRACO",
2850:"DOLOMEDES",
2851:"DOKEBI",
2852:"DISGUISE",
2853:"DIMIK_1",
2854:"DEVIRUCHI",
2855:"DESERT_WOLF_B",
2856:"DESERT_WOLF_B",
2857:"DENIRO",
2858:"DEATHWORD",
2859:"DEATHWORD",
2860:"DEATHWORD",
2861:"DARK_PRIEST",
2862:"DANCING_DRAGON",
2863:"CREAMY",
2864:"CORNUTUS",
2865:"COOKIE",
2866:"CONSTANT",
2867:"COMODO",
2868:"COCO",
2869:"COCO",
2870:"CLOCK",
2871:"CLOCK",
2872:"CHOCHO",
2873:"CENTIPEDE",
2874:"CENERE",
2875:"CELIA",
2876:"CATERPILLAR",
2877:"CARAT",
2878:"CARAMEL",
2879:"BUNGISNGIS",
2880:"BREEZE",
2881:"BREEZE",
2882:"BRADIUM_GOLEM",
2883:"BLOOD_BUTTERFLY",
2884:"BIGFOOT",
2885:"BATHORY",
2886:"BANSHEE_MASTER",
2887:"BANSHEE",
2888:"BANASPATY",
2889:"ASSULTER",
2890:"ARGOS",
2891:"ARGIOPE",
2892:"ARGIOPE",
2893:"ARCLOUSE",
2894:"ARCLOUSE",
2895:"APOCALIPS",
2896:"ANTLER_SCARABA",
2897:"ANTIQUE_BOOK",
2898:"ANTIQUE_BOOK",
2899:"ANOLIAN",
2900:"ANGRA_MANTIS",
2901:"ANGRA_MANTIS",
2902:"ANDRE",
2903:"ANCIENT_MIMIC",
2904:"ANACONDAQ",
2905:"AMBERNITE",
2906:"ALNOLDI",
2907:"ALLIGATOR",
2908:"ALIZA",
2909:"ALICEL",
2910:"ALARM",
2911:"AGAV",
2912:"ACIDUS_",
2913:"ACIDUS_",
2914:"E_GEFFEN_MAGE_3_1",
2916:"BIG_BEN",
2917:"BIG_BELL",
2918:"TIME_KEEPER",
2919:"NEO_PUNK",
2920:"ARC_ELDER",
2921:"OWL_VISCOUNT",
2922:"OWL_VISCOUNT",
2923:"OWL_MARQUEES",
2924:"T_ELDER_WILOW",
2925:"T_WILOW",
2926:"T_HARPY",
2927:"T_MINERAL",
2928:"T_GIBBET",
2929:"T_PLASMA_G",
2930:"T_SOLACE",
2931:"T_METALING",
2932:"T_POPORING",
2933:"T_DEVILING",
2934:"T_ARCHANGELING",
2935:"T_EVIL_CLOUD_HERMIT",
2936:"E_GHOSTRING",
2937:"M_LOKI",
2938:"MAGIC_SEAL",
2939:"EVIL_SHADOW1",
2940:"EVIL_SHADOW2",
2941:"EVIL_SHADOW3",
2942:"EVIL_FANATICS",
2943:"ICE_MINE",
2948:"CURSED_SOLDIER",
2949:"CURSED_SENTINEL",
2950:"BROKEN_MIND",
2951:"FLOATING_WORD",
2952:"LIKE_LOVE",
2953:"CURSED_MEMORY",
2954:"COLORLESS_VOW",
2955:"OLD_FRIENDSHIP",
2956:"SWEET_SLAUGHTER",
2957:"FORGOTTEN_NAME",
2958:"FATAL_DAYS",
2959:"TORTUROUS_REDEEMER",
2960:"FLAMECROSS",
2961:"TORTUROUS_REDEEMER",
2987:"XM_TREE",
2988:"XM_ANTONIO",
2989:"XM_COOKIE",
2990:"XM_CRUISER",
2991:"XM_MYSTCASE",
2992:"XM_LUDE",
2993:"XM_HYLOZOIST",
2994:"XM_MARIONETTE",
2995:"XM_TEDDY_BEAR",
2996:"XM_CELINE_KIMI",
2997:"CELINE_KIMI",
2998:"EP14_MORS_EVENT",
2999:"EP14_MORS_BOSSA",
3000:"EP14_MORS_BOSSB",
3001:"EP14_MORS_MOB1",
3002:"EP14_MORS_MOB2",
3003:"EP14_MORS_MOB3",
3004:"EP14_MORS_MOB4",
3005:"EP14_MORS_MOB5",
3006:"EP14_MORS_MOB6",
3007:"EP14_MORS_DUMMY",
3008:"EP14_MORS_HIDDEN",
3010:"EP14_3_DEATH_A_MOB1",
3011:"EP14_3_DEATH_A_MOB2",
3012:"EP14_3_DEATH_A_MOB3",
3013:"EP14_3_DEATH_B_MOB1",
3014:"EP14_3_DEATH_B_MOB2",
3015:"EP14_3_DEATH_B_MOB3",
3016:"EP14_3_DEATH_C_MOB1",
3017:"EP14_3_DEATH_C_MOB2",
3018:"EP14_3_DEATH_C_MOB3",
3020:"FIRE_CONDOR",
3021:"FIRE_SAND_MAN",
3022:"FIRE_FRILLDORA",
3023:"FIRE_GOLEM",
3026:"FIREPIT",
3027:"FULBUK",
3028:"SONIA",
3029:"GRIM_REAPER_ANKOU",
3038:"HIDDEN_MOB7",
3039:"B_MOROCC_1",
3040:"B_MOROCC_2",
3041:"B_MOROCC_4",
3061:"ANGRY_MIMIC",
3069:"PERE1",
3070:"PERE2",
3071:"PERE3",
3072:"PERE4",
3073:"GRAND_PERE",
3074:"TIMEHOLDER",
3075:"WA_TREASURE",
3076:"WA_MONSTER_1",
3077:"WA_MONSTER_2",
3078:"WA_MONSTER_3",
3079:"WA_MONSTER_4",
3080:"WA_MONSTER_5",
3081:"WA_MONSTER_6",
3082:"WA_MONSTER_7",
3083:"WA_MONSTER_8",
3084:"WA_MONSTER_9",
3085:"WA_MONSTER_10",
3086:"WA_MERCENARY",
3087:"M_NYDHOG",
3088:"BRINARANEA_BABY",
3089:"LOCO_KASA",
3090:"LOCO_SALAMANDER",
3091:"BRINARANEA",
3092:"MUSPELLSKOLL",
3096:"MOROCC_KID",
3097:"MOROCC_ADT",
3098:"MOROCC_ORIGIN",
3099:"MOROCC_REST",
3101:"MANA_WHITE",
3102:"MANA_RED",
3103:"MANA_YELLOW",
3105:"GB_MOROCC_1",
3106:"GB_MOROCC_4",
3108:"JITTERBUG1",
3109:"JITTERBUG2",
3122:"CHARLESTON1",
3123:"CHARLESTON2",
3124:"CHARLESTON3",
3125:"STEP",
3126:"ROCK_STEP",
3127:"KICK_STEP",
3128:"KICK_AND_KICK",
3153:"EXCAVATOR_ROBOT",
3154:"RECON_ROBOT",
3155:"REPAIR_ROBOT",
3156:"EXPLORATION_ROVER",
3157:"RUIN_BELIEVER1",
3158:"RUIN_BELIEVER2",
3159:"ILLEGAL_PROMOTION",
3161:"BOMB",
3169:"J_REB_SHECIL1",
3170:"J_REB_SHECIL2",
3175:"ROTAR_ZAIRO",
3176:"GREMLIN",
3177:"BEHOLDER",
3178:"ACIDUS",
3179:"ACIDUS_",
3180:"NYDHOG",
3181:"FELOCK",
3190:"SARAH",
3191:"M_GIGAN1",
3192:"M_GIGAN2",
3193:"M_GIGAN3",
3194:"L_GIGAN1",
3195:"L_GIGAN2",
3196:"L_GIGAN3",
3197:"M_GARGOYLE",
3198:"M_GALION",
3199:"M_MUTANT_DRAGON",
3200:"M_CHIMERA",
3202:"ORGANIC_JAKK",
3203:"INORGANIC_JAKK",
3208:"V_EREMES",
3209:"V_MAGALETA",
3210:"V_KATRINN",
3211:"V_SHECIL",
3212:"V_HARWORD",
3213:"V_SEYREN",
3214:"V_G_EREMES",
3215:"V_G_MAGALETA",
3216:"V_G_KATRINN",
3217:"V_G_SHECIL",
3218:"V_G_HARWORD",
3219:"V_G_SEYREN",
3220:"V_B_EREMES",
3221:"V_B_MAGALETA",
3222:"V_B_SHECIL",
3223:"V_B_HARWORD",
3224:"V_B_KATRINN",
3225:"V_B_SEYREN",
3226:"V_RANDEL",
3227:"V_FLAMEL",
3228:"V_CELIA",
3229:"V_CHEN",
3230:"V_GERTIE",
3231:"V_ALPHOCCIO",
3232:"V_TRENTINI",
3233:"V_G_RANDEL",
3234:"V_G_FLAMEL",
3235:"V_G_CELIA",
3236:"V_G_CHEN",
3237:"V_G_GERTIE",
3238:"V_G_ALPHOCCIO",
3239:"V_G_TRENTINI",
3240:"V_B_RANDEL",
3241:"V_B_FLAMEL",
3242:"V_B_CELIA",
3243:"V_B_CHEN",
3244:"V_B_GERTIE",
3245:"V_B_ALPHOCCIO",
3246:"V_B_TRENTINI",
3247:"CENERE_G",
3248:"REPAIR_ROBOT_T",
3249:"EXPLORATION_ROVER_T",
3250:"SCR_MT_ROBOTS",
3251:"GC109",
3252:"DR815",
3253:"SYS_MSG",
3254:"T_W_O",
3255:"GHOUL_H",
3256:"ZOMBIE_H",
3384:"PORING",
3385:"LUNATIC",
3386:"FABRE",
3387:"PICKY",
3388:"CONDOR",
3389:"WILOW",
3390:"SPORE",
3391:"POPORING",
3392:"SMOKIE",
3393:"DOKEBI",
3394:"BIGFOOT",
3395:"WORM_TAIL",
3396:"WOLF",
3397:"SNAKE",
3398:"ANACONDAQ",
3399:"MARIN",
3400:"MUKA",
3401:"PECOPECO",
3402:"DENIRO",
3403:"PIERE",
3404:"ANDRE",
3405:"GOLEM",
3406:"SCORPION",
3407:"CHOCHO",
3408:"METALLER",
3409:"SAND_MAN",
3410:"RAGGLER",
3411:"DRAGON_TAIL",
3412:"GREEN_IGUANA",
3413:"SEE_OTTER",
3414:"GALAPAGO",
3415:"FUR_SEAL",
3416:"ALLIGATOR",
3417:"MEGALODON",
3418:"TRI_JOINT",
3419:"MEGALITH",
3420:"DRYAD",
3421:"TOAD",
3422:"VAGABOND_WOLF",
3423:"VOCAL",
3424:"ECLIPSE",
3425:"CHIMERA",
3426:"EDDGA",
3427:"OSIRIS",
3428:"PHREEONI",
3429:"ORK_HERO",
3430:"TAO_GUNKA",
3431:"RODA_FROG",
3432:"WOLF",
3433:"ROCKER",
3434:"LUNATIC",
3435:"GARGOYLE",
3436:"BIGFOOT",
3437:"ANCIENT_MUMMY",
3438:"SAND_MAN",
3439:"HIGH_ORC",
3440:"MEGALITH",
3442:"FROZENWOLF",
3443:"TAFFY",
3444:"WATCHER",
3445:"P_ARCHER_SKELETON",
3446:"P_SKELETON",
3447:"P_SOLDIER_SKELETON",
3448:"P_AMDARAIS",
3449:"G_P_AMDARAIS",
3450:"BIJOU",
3451:"IMMOTAL_CORPS",
3452:"ZOMBIE_GUARD",
3454:"HEART_HUNTER_N",
3455:"GLASS_PLATE",
3473:"AS_RAGGED_GOLEM",
3474:"AS_BLOODY_KNIGHT",
3475:"AS_WIND_GHOST",
3476:"AS_ZOMBIE",
3477:"AS_IMMORTAL_CORPS",
3478:"AS_ZOMBIE_SLAUGHTER",
3479:"AS_ZOMBIE_MASTER",
3480:"AS_CURSED_SOLDIER",
3481:"AS_EVIL_SHADOW1",
3482:"AS_EVIL_SHADOW2",
3483:"AS_EVIL_SHADOW3",
3484:"AS_D_RAGGED_GOLEM",
3485:"AS_D_CURSED_SOLDIER",
3487:"CH1_IMMORTAL_CORPS1",
3488:"CH1_IMMORTAL_CORPS2",
3489:"CH1_IMMORTAL_CORPS3",
3490:"CH1_IMMORTAL_CORPS2",
3494:"IFN_POIRING",
3495:"DR_EGGRING",
3496:"DR_LUNATIC",
3497:"DR_FABRE",
3498:"DR_HORNET",
3499:"DR_RODA_FROG",
3500:"DR_DESERT_WOLF_B",
3501:"DR_SPORE",
3502:"DR_BASILISK1",
3503:"DR_BASILISK2",
3504:"DR_BASILISK3",
3505:"DR_BIG_EGGRING",
3506:"DR_MANDRAGORA",
3507:"DR_POM_SPIDER",
3508:"DR_EGGRING_G",
3510:"POPE_GUARD",
3511:"AUNOE",
3512:"FANAT",
3513:"HELL_POODLE",
3514:"POPE_BISHOP",
3515:"POPE_ICICLE",
3516:"POPE_LUWMIN",
3517:"POPE_TITAN",
3518:"POPE_GUARD",
3519:"AUNOE",
3520:"FANAT",
3521:"HELL_POODLE",
3522:"POPE_BISHOP",
3523:"POPE_ICICLE",
3524:"POPE_LUWMIN",
3525:"POPE_TITAN",
3526:"POPE_KTULLANUX",
3527:"POPE_NORMAL",
3528:"POPE_CASUAL",
3569:"POPE_NORMAL",
3570:"POPE_CASUAL",
3621:"EP16_2_CUTIE",
3622:"EP16_2_S_GUARDS",
3623:"EP16_2_U_ENERGY_R",
3624:"EP16_2_U_ENERGY_G",
3625:"EP16_2_U_ENERGY_B",
3626:"EP16_2_H_HUNTER_V",
3627:"EP16_2_H_HUNTER_MD",
3628:"EP16_2_H_HUNTER_EV",
3629:"EP16_2_BROKEN_GUN",
3630:"EP16_2_E_BOLKOBA",
3631:"EP16_2_HUMAN_KIMERA",
3632:"EP16_2_MATTER_KIMERA",
3633:"EP16_2_VENOM_KIMERA",
3636:"LITTLE_ISIS",
3637:"SKELETON",
3638:"SKELETON",
3639:"SKELETON",
3640:"SKELETON",
3641:"SKELETON",
3642:"SKELETON",
3643:"FARMILIAR",
3644:"FARMILIAR",
3645:"FARMILIAR",
3646:"FARMILIAR",
3647:"FARMILIAR",
3648:"FARMILIAR",
3649:"ZOMBIE",
3650:"ZOMBIE",
3651:"ZOMBIE",
3652:"ZOMBIE",
3653:"ZOMBIE",
3654:"ZOMBIE",
3658:"LICH_LORD",
3659:"LICH_LORD",
3660:"NIGHTMARE",
3661:"NIGHTMARE",
3662:"JAKK",
3663:"JAKK",
3664:"GHOUL",
3665:"GHOUL",
3666:"DRAINLIAR",
3667:"DRAINLIAR",
3669:"DIABOLIC2",
3670:"DELETER_2",
3736:"COWRAIDERS1",
3737:"COWRAIDERS2",
3738:"COWRAIDERS3",
3739:"COYOTE",
3740:"GASTER",
3741:"MECHASPIDER",
3742:"PURPLESTONE",
3743:"SEAANEMONE",
3744:"G_COWRAIDERS1",
3745:"G_COWRAIDERS2",
3746:"G_COWRAIDERS3",
3747:"E_COWRAIDERS1",
3748:"E_COWRAIDERS2",
3749:"E_COWRAIDERS3",
3750:"ILL_DRAINLIAR",
3751:"ILL_ZOMBIE_C",
3752:"ILL_ZOMBIE",
3753:"ILL_GHOUL",
3754:"ILL_NIGHTMARE",
3755:"ILL_BLACK_MUSHROOM",
3756:"ILL_BOMI",
3757:"ILL_DRACULA",
3758:"ILL_MOONLIGHT",
3759:"ILL_NINE_TAIL",
3760:"ILL_MUNAK",
3761:"ILL_BON_GUN",
3762:"ILL_SOHEE",
3763:"ILL_ARCHER_SKELETON",
3764:"ILL_HIGHWIZARD",
3765:"ILL_FURY_HERO",
3787:"ARCLOUSE",
3788:"CRAMP",
3790:"SWEETS_DROPS",
3792:"ILL_GAZETI",
3793:"ILL_SNOWIER",
3794:"ILL_ICE_TITAN",
3795:"ILL_ICEICLE",
3796:"ILL_KTULLANUX",
3797:"ILL_FROZEN_KN",
3798:"ILL_FROZEN_GC",
3799:"ILL_ASSULTER",
3800:"ILL_PERMETER",
3801:"ILL_FREEZER",
3802:"ILL_SOLIDER",
3803:"ILL_HEATER",
3804:"ILL_TURTLE_GENERAL",
3810:"KING_PORING",
3811:"GOLDPORING",
3812:"PORING",
3813:"DROPS",
3814:"POPORING",
3815:"PORING",
3816:"MARIN",
3896:"G_ILL_ASSULTER",
20255:"TEDDY_BEAR_R",
20256:"TEDDY_BEAR_Y",
20257:"TEDDY_BEAR_G",
20258:"TEDDY_BEAR_W",
20259:"TEDDY_BEAR_B",
20260:"TEDDY_BEAR_S",
20261:"PITMAN_IL",
20262:"MINERAL_IL",
20263:"OBSIDIAN_IL",
20264:"TEDDY_BEAR_R",
20265:"TEDDY_BEAR_Y",
20266:"TEDDY_BEAR_G",
20267:"TEDDY_BEAR_W",
20268:"TEDDY_BEAR_B",
20269:"GUILD_SKILL_FLAG",
20270:"ILL_TRI_JOINT",
20271:"ILL_STALACTIC_GOLEM",
20272:"ILL_MEGALITH",
20273:"ILL_TAO_GUNKA",
20274:"ILL_STONE_SHOOTER",
20275:"ILL_WOOTAN_SHOOTER",
20276:"ILL_WOOTAN_FIGHTER",
20277:"ILL_WOOTAN_DEFENDER",
20278:"ILL_MEGALITH",
20279:"ILL_WOOTAN_SHOOTER",
20280:"ILL_WOOTAN_FIGHTER",
20340:"MD_EL_A17T",
20341:"MD_E_EA1L",
20342:"MD_E_EA2S",
20343:"MD_E_13EN0",
20344:"MD_VENOM_BUG",
20345:"MD_CONSTANT",
20346:"MD_MIGUEL",
20347:"MD_MIGUEL_G",
20348:"MD_A013_CAPUT",
20349:"MD_A013_DOLOR",
20350:"MD_A013_BELLARE",
20351:"MD_MANHOLE2",
20352:"MD_POMPOM",
20353:"MD_CROB",
20355:"EP17_1_BELLARE1",
20356:"EP17_1_BELLARE2",
20357:"EP17_1_SANARE1",
20358:"EP17_1_SANARE2",
20359:"EP17_1_PLAGA1",
20360:"EP17_1_PLAGA2",
20361:"EP17_1_DOLOR1",
20362:"EP17_1_DOLOR2",
20363:"EP17_1_VENENUM1",
20364:"EP17_1_VENENUM2",
20365:"EP17_1_TWIN_CAPUT1",
20366:"EP17_1_TWIN_CAPUT2",
20367:"RAYDRIC_MJ",
20368:"RAYDRIC_ARCHER_MJ",
20369:"GARGOYLE_MJ",
20370:"STING_MJ",
20371:"RAGGED_ZOMBIE_MJ",
20372:"BLAZZER_MJ",
20373:"NIGHTMARE_TERROR_MJ",
20374:"DELETER1_MJ",
20375:"DELETER2_MJ",
20376:"EXPLOSION_MJ",
20377:"KAHO_MJ",
20378:"LAVA_GOLEM_MJ",
20379:"ICE_GHOST",
20380:"FLAME_GHOST",
20381:"EP17_1_R4885_BESTIA",
20382:"G_TWIN_CAPUT2",
20419:"MUSPELLSKOLL_H",
20420:"WANDER_MAN_H",
20421:"BRINARANEA_H",
20422:"DARK_LORD_H",
20543:"MD_ED_M_SCIENCE",
20560:"G_MINERAL_G",
20592:"POISONOUS",
20593:"TOXIOUS",
20594:"MINERAL_G",
20595:"MINERAL_R",
20596:"MINERAL_W",
20597:"MINERAL_P",
20598:"JEWELIANT",
20599:"G_JEWELIANT",
20600:"JEWEL",
20601:"JUNGOLIANT",
20602:"PORCELLIO_W",
20603:"ABYSSMAN",
20620:"MD_REDPEPPER",
20621:"MD_REDPEPPER_H",
20622:"MD_ASSISTANT",
20623:"MD_ASSISTANT_H",
20624:"MD_DRY_RAFFLESIA",
20625:"MD_DRY_RAFFLESIA_H",
20626:"MD_ALNOLDI_EX",
20627:"MD_ALNOLDI_EX_H",
20628:"EP17_2_ALPHA_MASTER",
20629:"EP17_2_BETA_BASIC",
20630:"EP17_2_BETA_BASIC_NG",
20631:"MD_BETA_SCISSORE_NG",
20632:"MD_BETA_SCISSORE_NG_H",
20633:"EP17_2_BETA_CLEANER_A",
20634:"EP17_2_BETA_CLEANER_B",
20635:"EP17_2_BETA_BATHS_A",
20636:"EP17_2_BETA_BATHS_B",
20637:"EP17_2_BETA_ITEMKEEPER",
20638:"EP17_2_BETA_GUARDS",
20639:"EP17_2_BETA_GUARDS_NG",
20640:"EP17_2_OMEGA_CLEANER",
20641:"EP17_2_OMEGA_CLEANER_NG",
20642:"SWEETY",
20643:"PHEN",
20644:"MARC",
20645:"SWORD_FISH",
20646:"PIRANHA",
20647:"BATH_MERMAID",
20648:"PITAYA_BOSS",
20649:"PITAYA_R",
20650:"PITAYA_Y",
20651:"PITAYA_B",
20652:"PITAYA_V",
20653:"PITAYA_G",
20654:"PITAYA_R",
20655:"PITAYA_Y",
20656:"PITAYA_B",
20657:"PITAYA_V",
20658:"PITAYA_G",
20659:"PITAYA_BOSS",
20660:"PITAYA_R",
20661:"PITAYA_Y",
20662:"PITAYA_B",
20663:"PITAYA_V",
20664:"PITAYA_G",
20665:"VERPORTA",
20666:"VERPORTE_H",
20667:"SILVA_PAPILIA",
20668:"GRAN_PAPILIA",
20669:"PAPILA",
20670:"PAPILA_H",
20671:"PAPILA_RUBA",
20672:"PAPILA_RUBA_H",
20673:"PAPILA_RUBA2",
20674:"PAPILA_CAE",
20675:"PAPILA_CAE_H",
20676:"PAPILA_CAE2",
20677:"ARIES",
20678:"ARIES_H",
20679:"EP17_2_GUARDIAN_PARTS",
20680:"HEART_HUNTER",
20681:"HEART_HUNTER",
20682:"HEART_HUNTER_H",
20683:"BOOKWORM",
20684:"ROAMING_SPLBOOK",
20685:"EP17_2_VENENUM",
20686:"EP17_2_CRAMP",
20687:"EP17_2_WATERFALL",
20688:"BELLARE",
20689:"DOLOR",
20690:"PLASMA_Y",
20691:"PLAGA3",
20692:"EP17_2_SANARE",
20693:"PLASMA_R",
20694:"PLASMA_R",
20696:"CHILD_ADMIN1",
20697:"CHILD_ADMIN2",
20698:"ASSISTANT",
20699:"BELLARE",
20700:"BETA_SCISSORE_NG",
20801:"ILL_SROPHO",
20802:"ILL_OBEAUNE",
20803:"ILL_DEVIACE",
20804:"ILL_MARSE",
20805:"ILL_MERMAN",
20806:"ILL_SEDORA",
20807:"ILL_SWORD_FISH",
20808:"ILL_STROUF",
20809:"ILL_PHEN",
20810:"ILL_KING_DRAMOH",
20811:"ILL_KRAKEN",
20834:"ABR_BATTLE_WARIOR",
20835:"ABR_DUAL_CANNON",
20836:"ABR_MOTHER_NET",
20837:"ABR_INFINITY",
20843:"ILL_ABYSMAL_WITCH",
20846:"MD_HIDDEN_GROUND01",
20847:"MD_HIDDEN_GROUND02",
20848:"SUMMON_WOODENWARRIOR",
20849:"SUMMON_WOODEN_FAIRY",
20850:"SUMMON_CREEPER",
20851:"SUMMON_HELLTREE",
20920:"CHIMERA_LAVA",
20921:"CHIMERA_FULGOR",
20922:"CHIMERA_NAPEO",
20923:"CHIMERA_GALENSIS",
20924:"CHIMERA_AMITERA",
20925:"CHIMERA_LITUS",
20926:"CHIMERA_FILLIA",
20927:"CHIMERA_VANILAQUS",
20928:"CHIMERA_THEONE",
20929:"GIANT_CAPUT",
20930:"DOLORIAN",
20931:"PLAGARION",
20932:"DEADRE",
20933:"VENEDI",
20934:"R001_BESTIA",
20935:"GAN_CEANN",
20936:"DISGUISER",
20937:"BRUTAL_MURDERER",
20938:"GHOST_CUBE",
20939:"LUDE_GAL",
20940:"BLUEMOON_LOLI_RURI",
20941:"GROTE",
20942:"PIERROTZOIST",
20943:"DEATH_WITCH",
21064:"S_DUMMY_100_SMALL",
21065:"S_DUMMY_100_MEDIUM",
21066:"S_DUMMY_100_LARGE",
21067:"S_DUMMY_100_NOTHING",
21068:"S_DUMMY_100_DRAGON",
21069:"S_DUMMY_100_ANIMAL",
21070:"S_DUMMY_100_HUMAN",
21071:"S_DUMMY_100_INSECT",
21072:"S_DUMMY_100_FISH",
21073:"S_DUMMY_100_DEMON",
21074:"S_DUMMY_100_PLANT",
21075:"S_DUMMY_100_ANGEL",
21076:"S_DUMMY_100_UNDEAD",
21077:"S_DUMMY_100_NOTHING2",
21078:"S_DUMMY_100_WATER",
21079:"S_DUMMY_100_GROUND",
21080:"S_DUMMY_100_FIRE",
21081:"S_DUMMY_100_WIND",
21082:"S_DUMMY_100_POISON",
21083:"S_DUMMY_100_SAINT",
21084:"S_DUMMY_100_DARKNESS",
21085:"S_DUMMY_100_TELEKINESIS",
21086:"S_DUMMY_100_UNDEAD2",
21292:"EP18_ARMED_VILLAGER01",
21293:"EP18_ARMED_VILLAGER02",
21294:"EP18_ARMED_VILLAGER03",
21295:"EP18_ASH_TOAD",
21296:"EP18_RAKEHAND",
21297:"EP18_SPARK",
21298:"EP18_HOT_MOLAR",
21299:"EP18_VOLCARING",
21300:"EP18_LAVA_TOAD",
21301:"EP18_BURNING_FANG",
21302:"EP18_ASHHOPPER",
21303:"EP18_ASHRING",
21304:"EP18_GREY_WOLF",
21305:"EP18_TUMBLE_RING",
21306:"EP18_FIREWIND_KITE",
21307:"EP18_PHANTOM_WOLF",
21308:"EP18_MD_HEARTHUNTER_A",
21309:"EP18_MD_THOR_GUARD",
21310:"EP18_MD_GUARD_A",
21311:"EP18_MD_GUARD_B",
21312:"EP18_MD_HEARTHUNTER_R",
21313:"EP18_MD_HEARTHUNTER_F",
21314:"EP18_MD_SCHULANG",
21315:"EP18_MD_DEMI_FREYJA",
21316:"EP18_MD_SCHULANG_R",
21317:"EP18_MD_DEMI_FREYJA_R",
21318:"EP18_MD_SANARE_R",
21319:"EP18_MD_HEARTHUNTER_R2",
21320:"EP18_NPC_MARAM",
21321:"EP18_NPC_MIRIAM",
21322:"EP18_NPC_SUAD",
21323:"EP18_GREY_GOAT",
21324:"EP18_GREY_WOLF_BABY",
21360:"EP18_MD_SCHULANG_L",
21361:"EP18_MD_DEMI_FREYJA_L",
21377:"EP18_MD_SANARE_L",
21378:"EP18_MD_HEARTHUNTER_L",
21386:"ILL_ANDRE",
21387:"ILL_SOLDIER_ANDR",
21388:"ILL_ANDRE_LARVA",
21389:"ILL_DENIRO",
21390:"ILL_PIERE",
21391:"ILL_ANT_EGG",
21392:"ILL_GIEARTH",
21393:"ILL_FARMILIAR",
21394:"ILL_VITATA",
21395:"ILL_MAYA",
21513:"EP19_NPC_IWIN",
21514:"EP19_NPC_IWIN_SN",
21515:"EP19_NPC_IWIN_SY",
21516:"EP19_NPC_IWIN_SB",
21517:"EP19_NPC_IWIN_SG",
21518:"EP19_NPC_IWIN_SR",
21519:"EP19_NPC_LEHAR",
21520:"EP19_LIMACINA",
21521:"EP19_UNFROST_FLOWER",
21522:"EP19_CALMARING",
21523:"EP19_ICE_STRAW",
21524:"EP19_SHINING_SEAWEED",
21525:"EP19_ICE_GANGU",
21526:"EP19_RGAN_A",
21527:"EP19_RGAN_B",
21528:"EP19_RGAN_C",
21529:"EP19_RGAN_D",
21530:"EP19_RGAN_E",
21531:"EP19_MD_AQUILA",
21532:"EP19_MD_JUNCEA",
21533:"EP19_MD_JUNCEA_S",
21534:"EP19_MD_RGAN_E",
21535:"EP19_MD_RGAN_D",
21536:"EP19_MD_HEARTHUNTER_AT",
21537:"EP19_LIMACINA_BOSS",
21538:"EP19_WASTED_RGAN_A",
21539:"EP19_WASTED_RGAN_C",
21540:"EP19_CAVE_CALMARING",
21541:"EP19_CAVE_FLOWER",
21542:"EP19_HALLUCIGENIA",
21543:"EP19_HALLUCIGENIA_BABY",
21544:"EP19_ONE_EYE_DOLLOCARIS",
21545:"EP19_DOLLOCARIS",
21588:"EP19_MD_AQUILA_B",
21589:"G_EP19_LIMACINA",
21590:"EP19_MD_RGAN_ES",
21599:"EP19_HEARTHUNTER_AT",
21600:"EP19_RE_RGAN_E",
21601:"EP19_ET_RGAN_D",
21853:"EP19_MD_BOX1",
21854:"EP19_MD_BOX2",
21866:"HEROS_IN_ORB_1",
21867:"HEROS_IN_ORB_2",
21868:"HEROS_IN_ORB_3",
21869:"HEROS_IN_ORB_4",
21887:"HEROS_OUT_ORB",
22177:"MD_PRI_DRAGON_1",
22178:"MD_PRI_DRAGON_2",
22179:"MD_PRI_DRAGON_3",
22180:"MD_PRI_DRAGON_4",
22192:"SPIRIT_G_LAND_S",
22193:"SPIRIT_G_LAND_M",
22194:"SPIRIT_G_LAND_L",
22195:"SPIRIT_G_LAND_SL",
22196:"SPIRIT_B_FLAME_S",
22197:"SPIRIT_B_FLAME_M",
22198:"SPIRIT_B_FLAME_L",
22199:"SPIRIT_B_FLAME_SL",
22200:"SPIRIT_S_WIND_S",
22201:"SPIRIT_S_WIND_M",
22202:"SPIRIT_S_WIND_L",
22203:"SPIRIT_S_WIND_SL",
22204:"SPIRIT_I_WATER_S",
22205:"SPIRIT_I_WATER_M",
22206:"SPIRIT_I_WATER_L",
22207:"SPIRIT_I_WATER_SL",
22208:"SPIRIT_C_LAND_S",
22209:"SPIRIT_C_LAND_M",
22210:"SPIRIT_C_LAND_L",
22211:"SPIRIT_C_LAND_SL",
22212:"SPIRIT_C_FLAME_S",
22213:"SPIRIT_C_FLAME_M",
22214:"SPIRIT_C_FLAME_L",
22215:"SPIRIT_C_FLAME_SL",
22216:"SPIRIT_H_WATER_S",
22217:"SPIRIT_H_WATER_M",
22218:"SPIRIT_H_WATER_L",
22219:"SPIRIT_H_WATER_SL",
22220:"SPIRIT_D_WIND_S",
22221:"SPIRIT_D_WIND_M",
22222:"SPIRIT_D_WIND_L",
22223:"SPIRIT_D_WIND_SL",
22224:"SPIRIT_R_FLAME_S",
22225:"SPIRIT_R_FLAME_M",
22226:"SPIRIT_R_FLAME_L",
22227:"SPIRIT_R_FLAME_SL",
22228:"SPIRIT_F_LAND_S",
22229:"SPIRIT_F_LAND_M",
22230:"SPIRIT_F_LAND_L",
22231:"SPIRIT_F_LAND_SL",
22232:"SPIRIT_C_WATER_S",
22233:"SPIRIT_C_WATER_M",
22234:"SPIRIT_C_WATER_L",
22235:"SPIRIT_C_WATER_SL",
22236:"SPIRIT_C_WIND_S",
22237:"SPIRIT_C_WIND_M",
22238:"SPIRIT_C_WIND_L",
22239:"SPIRIT_C_WIND_SL"
}
